export const GET_OWNER_DEALS = '[Deals] Get owner deals';
export const GET_OWNER_DEALS_SUCCESS = '[Deals] Get owner deals Success';
export const GET_OWNER_DEALS_ERROR = '[Deals] Get owner deals Error';

export const GET_ARTIST_DEALS = '[Deals] Get artist deals';
export const GET_ARTIST_DEALS_SUCCESS = '[Deals] Get artist deals Success';
export const GET_ARTIST_DEALS_ERROR = '[Deals] Get artist deals Error';

export const RESET_DEALS_STATE = '[Deals] Clear deals state';
